import { CONTACT_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
export const getCustomObjectResolverOptions = (objectType, includeDeletes = false) => {
  const additionalProperties = ['archived'];
  if (objectType.getObjectTypeId() === CONTACT_ID) {
    additionalProperties.push('hs_marketable_status');
  }
  return {
    fetchQueryParams: {
      properties: [...(objectType.getSearchProperties() || []), ...additionalProperties],
      includeDeletes
    },
    formatterOptions: {
      getters: {
        getLabel: object => objectType.getLabel(object)
      }
    }
  };
};
export const getInboundDbReadScopesFromObject = obj => {
  const scopes = [];
  if (obj.accessScopeName) {
    scopes.push(obj.accessScopeName);
  }
  if (obj.readScopeName) {
    scopes.push(obj.readScopeName);
  }
  return scopes;
};